(function () {

    angular
        .module('smartertoolsApp')
        .controller('betaSignupController', ['$scope', '$http', 'authenticationService', betaSignupController]);

    function betaSignupController($scope, $http, authenticationService) {
        const vm = this;
        vm.emailAddress = authenticationService.getLoggedInEmail();
        vm.mode = authenticationService.isLoggedIn() ? 'form' : 'login'; // requesting, completed and error are other possible results
        vm.product = 'smartermail';
        vm.productOptions = null;
        vm.productOptionSelection = null;
        vm.keySentTo = null;
        vm.keyExpires = null;

        // Functions
        vm.showLogin = showLogin;
        vm.getBetaKey = getBetaKey;
        activate();

        // -----------------------------------------------

        function activate() {
            $scope.$on('authentication:logged-in', onLoggedIn);
            $scope.$on('authentication:logged-out', onLoggedOut);

            const productTypeDiv = document.getElementById('productType');
            if (productTypeDiv)
                vm.product = productTypeDiv.getAttribute('data-product-type');

            queryAvailableProducts();
        }

        function onLoggedIn(event, data) {
            if (vm.mode === 'form' || vm.mode === 'login')
                vm.mode = authenticationService.isLoggedIn() ? 'form' : 'login';
            vm.emailAddress = authenticationService.getLoggedInEmail();

            $scope.$applyAsync();
            RecalculateAllFloatLabelControls();
        }

        function onLoggedOut(event, data) {
            if (vm.mode === 'form' || vm.mode === 'login')
                vm.mode = authenticationService.isLoggedIn() ? 'form' : 'login';
        }

        function showLogin() {
            ShowLoginOverlay();
        }

        function queryAvailableProducts() {
            $http
                .get(`${apiRootUrl}v1/${vm.product}/beta-license-types`)
                .then(
                    function (successResponse) {
                        if (successResponse.data.Items.length)
                            vm.productOptionSelection = successResponse.data.Items[0];
                        vm.productOptions = successResponse.data.Items;
                    },
                    function (errorResponse) {
                        vm.mode = 'error';
                    }
                );
        }

        function getBetaKey() {
            vm.mode = 'requesting';
            refreshTokenPassThrough(function () {
                $http({
                    method: 'POST',
                    url: `${apiRootUrl}v1/products/start-beta`,
                    headers: {"Authorization": 'BEARER ' + authenticationService.getAuthToken()},
                    data: {ProductId: vm.productOptionSelection.ProductId}
                }).then(
                    function (successResponse) {
                        vm.mode = 'completed';
                        vm.keySentTo = successResponse.data.EmailAddress;
                        vm.keyExpires = successResponse.data.ExpirationDateUtc;
                    },
                    function (errorResponse) {
                        vm.mode = 'error';
                    }
                );
            });
        }

        function refreshTokenPassThrough(callback) {
            const refreshToken = authenticationService.getRefreshToken();
            if (!refreshToken) {
                callback();
                return;
            }

            $http({
                method: 'POST',
                url: `${apiRootUrl}v1/auth/refresh-access-token`,
                data: {RefreshToken: refreshToken}
            }).then(function (successResponse) {
                authenticationService.setLoggedInEmail(successResponse.data.EmailAddress);
                authenticationService.setAuthToken(successResponse.data.AccessToken);
                callback();
            });
        }
    }

})();